<template>
    <div>
        <div v-if="loading" class="text-center">Loading...</div>
        <div v-else-if="failed" class="text-danger text-center">
            <i class="mdi mdi-warning"></i> An error occurred while fetching the autobooker status.
        </div>
        <div v-else>
            <div v-if="hasAutobookerRun">
                <div class="row">
                    <div class="col-md-6">
                        <AutobookerSteps @retryStep="handleRetryStep" :steps="autobookerRun.steps"/>
                    </div>
                    <div class="col-md-6">
                        <AutobookerFinance :autobooker-run="autobookerRun"></AutobookerFinance>
                    </div>
                </div>

            </div>
            <div v-else class="text-center text-muted">
                <i class="mdi mdi-information"></i> No Autobooker process was found yet. It will automatically start a
                few minutes after the payment has been processed.
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import AutobookerFinance from './AutobookerFinance';
import AutobookerSteps from './AutobookerSteps';

export default {
    name: "AutobookerStatus",

    props: {
        runId: {
            type: String,
            required: true
        },
        partnerId: {
            type: String,
            required: true
        }
    },

    data: () => ({
        loading: false,
        failed: false,
        hasAutobookerRun: false,
        autobookerRun: {
            status: null,
            finance: {
                income: null,
                income_currency: null,
                income_currency_value: null,
                budget: null,
                cost_expected: null,
                cost_real: null,
                margin_expected: null,
                margin_real: null
            },
            steps: []
        }
    }),

    mounted() {
        this.fetchAutobookerRun();
    },

    methods: {
        fetchAutobookerRun() {
            this.loading = true;
            axios.get('/admin/api/autobooker-runs/' + this.partnerId + '/' + this.runId).then((res) => {
                this.loading = false;
                this.hasAutobookerRun = true;
                Object.assign(this.autobookerRun, res.data.data);
            }).catch((err) => {
                this.loading = false;

                if (err.response.status === 404) {
                    this.hasAutobookerRun = false;
                    return;
                }

                this.failed = true;
            });
        },

        handleRetryStep(step) {
            this.retryAutobookerStep(step.id);
        },

        retryAutobookerStep(stepId) {
            axios.post(`/admin/api/autobooker-runs/${this.partnerId}/${this.runId}/steps/${stepId}/retry`);
        }
    },

    components: {
        AutobookerSteps,
        AutobookerFinance
    }
};
</script>

